$(() => {
  const startsHTTP = new RegExp('^https?://', 'i');
  const proxyString = 'https://libproxy.library.unt.edu:9443/login?url=';
  const $originalURL = $('#original-url');
  const $proxifiedURL = $('#proxified-url');
  const $transformed = $('#transformed');
  const $validMsg = $('#validation-msg-valid');
  const $invalidMsg = $('#validation-msg-invalid');

  // prevent form submission, nowhere to go
  $('#proxy-form').submit((e) => {
    e.preventDefault();
  });

  // actions on step 2 button click
  $('#update-url').on('click', () => {
      const originalVal = $originalURL.val();

      // if vale present, transform and show results
      // refocus if left blank
      if (originalVal !== '' && originalVal.match(startsHTTP)) {
        $transformed.show();

        $proxifiedURL.val(proxyString + originalVal)
          .select()
          .mouseup(() => false);

        if (originalVal.match(startsHTTP)) {
          $originalURL.addClass('is-valid').removeClass('is-invalid');
          $validMsg.show();
          $invalidMsg.hide();
        } else {
          $originalURL.addClass('is-invalid').removeClass('is-valid');
          $invalidMsg.show();
          $validMsg.hide();
        }
      } else {
        $originalURL.addClass('is-invalid').focus().get(0).setSelectionRange(0, 0);
        $validMsg.hide();
        $invalidMsg.show();
        $transformed.hide();
      }
  });

  // user wants to test the generated url. Open it in a new tab
  $('#test-me').on('click', () => {
    const proxied = $proxifiedURL.val();
    window.open(proxied);
  });
});
